export default "__VITE_ASSET__BV$2u$VW__"